export interface MyMeasuresEntry {
  title: string;
  numberOfEntriesLabel: string;
  lastEntryLabel: string;
  firstEntry: string;
  color: string;
  href: string;
  subType: string;
  icon: string;
  displayGraphToUser: boolean;
}

export interface MyMeasuresCategory {
  uuid: string;
  abspath: string;
  name: string;
  color: string;
  measures: Array<MyMeasuresEntry>;
}
